import {Box, Pagination} from '@mui/material';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getPendingPayments} from '../actions';
import {Filters} from '../components';
import CustomersTab from '../components/CustomTables/CustomersTable';
import useFilters from '../utils/useFilters';

const PendingPayments = () => {
  const dispatch = useDispatch();
  const {
    pendingPayments,
    pendingPaymentsPage,
    pendingPaymentsTotalPages,
    paymentsLoading,
  } = useSelector(s => s.payments);

  const filters = useFilters(val => dispatch(getPendingPayments(val)));

  const onPageChange = (e, value) => {
    dispatch(getPendingPayments({page: value, ...filters.filters}));
  };

  useEffect(() => {
    dispatch(getPendingPayments());
  }, []);

  return (
    <>
      <Filters m="1rem" withSearch withBuilding {...filters} />
      <CustomersTab
        customers={pendingPayments}
        loading={paymentsLoading}
        hideAddBtn
        pendingPayments
      />
      {pendingPaymentsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={pendingPaymentsTotalPages}
            page={pendingPaymentsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default PendingPayments;
